import { CloseCircleOutlined } from "@ant-design/icons";
import { Avatar, FloatButton } from "antd";
import { List, Toast } from "antd-mobile";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import ReactFileReader from "react-file-reader";
import { useNavigate } from "react-router-dom";
import PsContext from "../../context";
import { getFileLiveUrl, jsonToQuery, momentDate } from "../../utils";
import { SELECT_USER_PHOTO } from "../../utils/data";
import { ServiceUrl } from "../../utils/serviceUrl";
import Header from "../header";
import ViewFeedbackQuestions from "./viewFeedbackQuestions";

const FeedBack = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [listTitle, setListTitle] = useState([]);
  const [showList, setShowList] = useState(true);
  const [showQuestions, setShowQuestions] = useState(false);
  const [listQuestions, setListQuestions] = useState([]);
  const [selFeedback, setSelFeedback] = useState(null);
  const [studentSubject, setStudentSubjects] = useState([]);
  const [feedbackAudience, setFeedbackAudience] = useState([]);
  const handleListFeedbackTitle = () => {
    setLoader(true);
    setListTitle([]);
    getFeedbackSub().then((ressub) => {
      var tmpStudSubjectsArray = ressub.map((item) => item.subject_id.toString());
      setStudentSubjects(tmpStudSubjectsArray);
      axios
        .post(
          ServiceUrl.STUDENTS.LIST_FEEDBACK_TITLE +
            "?" +
            "student_uuid=" +
            context.user.uuid
        )
        .then((res) => {
          if (res["data"].status == "1") {
            setListTitle(res["data"].data);
            console.log(res["data"].data, ressub);
          } else {
            Toast.show({ content: res["data"].message || "Error" });
          }
          setLoader(false);
        });
    });
  };

  const getFeedbackSub = async (status = false) => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          ServiceUrl.STUDENTS.GET_FEEDBACK_SUB +
            "?" +
            "student_uuid=" +
            context.user.uuid
        )
        .then((res) => {
          if (res["data"].status == "1") {
            resolve(res["data"].data);
          } else {
            reject(res["data"].message || "Error");
          }
        });
    });
  };

  const getFeedbackAudience = async (status = false) => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          ServiceUrl.STUDENTS.GET_FEEDBACK_AUDIENCE +
            "?" +
            "student_uuid=" +
            context.user.uuid
        )
        .then((res) => {
          if (res["data"].status == "1") {
            resolve(res["data"].data);
            setFeedbackAudience(res["data"].data);
          } else {
            reject(res["data"].message || "Error");
          }
        });
    });
  };

  const getFeedbacks = () => {
    var finalFeedbacks = [];
    listTitle.forEach((item, index) => {
      var isAudience = true;
      var aud = feedbackAudience.filter((item) => item.type === "exclude");

      var filter = aud.map((item) => item.feedback_id);
      if (filter.includes(item.id)) isAudience = false;
      console.log(isAudience);
      if (isAudience) {
        if (item.target_subjects) {
          var target_subjects = item.target_subjects.toString().split(",");
          var isStudentSubject = false;
          target_subjects.forEach((obj) => {
            if (studentSubject.includes(obj)) isStudentSubject = true;
          });

          if (isStudentSubject) {
            finalFeedbacks.push(
              <List.Item
                key={index + 1}
                prefix={
                  <Avatar
                    style={{
                      backgroundColor: "#f56a00",
                      verticalAlign: "middle",
                      textTransform: "uppercase",
                    }}
                    size="large"
                  >
                    {item.feedback_title.charAt(0)}
                  </Avatar>
                }
                onClick={(e) => {
                  setShowList(false);
                  setShowQuestions(true);
                  setSelFeedback(item);
                }}
              >
                {item.feedback_title} <br />
                Last date: {momentDate(item.end_date, "DD-MM-YYYY")}
              </List.Item>
            );
          }
        } else {
          finalFeedbacks.push(
            <List.Item
              key={index + 1}
              prefix={
                <Avatar
                  style={{
                    backgroundColor: "#f56a00",
                    verticalAlign: "middle",
                    textTransform: "uppercase",
                  }}
                  size="large"
                >
                  {item.feedback_title.charAt(0)}
                </Avatar>
              }
              onClick={(e) => {
                setShowList(false);
                setShowQuestions(true);
                setSelFeedback(item);
              }}
            >
              {item.feedback_title} <br />
              Last date: {momentDate(item.end_date, "DD-MM-YYYY")}
            </List.Item>
          );
        }
      } else {
        finalFeedbacks.push(
          <h3 style={{ textAlign: "center" }}>No Current Feedbacks.</h3>
        );
      }
    });
    return finalFeedbacks;
  };
  useEffect(() => {
    handleListFeedbackTitle();
    getFeedbackSub();
    getFeedbackAudience();
  }, []);

  return (
    <>
      {showList && (
        <>
          <Header title="Feedback" backAction={true} rightActions={[]} />
          <div className="">
            <div className="container">
              <br />
              {listTitle.length == 0 && (
                <>
                  <h3 style={{ textAlign: "center" }}>No Current Feedbacks</h3>
                </>
              )}
              <List>{getFeedbacks()}</List>
            </div>
          </div>
        </>
      )}
      {showQuestions && (
        <>
          <Header title="Give Answer" backAction={true} rightActions={[]} />
          <ViewFeedbackQuestions
            feedback={selFeedback}
            onSuccess={() => {
              setShowList(true);
              setShowQuestions(false);
              handleListFeedbackTitle();
            }}
          />
        </>
      )}
    </>
  );
};
export default FeedBack;
